import React, { useState } from "react";
import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import "./../../components/CustomDate/CustomDatePicker.scss";
interface CustDatePickerProps {
  date: Date | null;
  setDate: (date: Date | null) => void;
}

const CustDatePicker: React.FC<CustDatePickerProps> = ({ date, setDate }) => {
  const [touched, setTouched] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const isValidDate = (date: any): date is Date =>
    date instanceof Date && !isNaN(date.getTime());

  const handleOk = (selectedDate: Date) => {
    if (isValidDate(selectedDate)) {
      setErrorMsg("");
    } else {
      setErrorMsg("Invalid date. Please select a valid date.");
    }
  };

  const handleChange = (selectedDate: Date | null) => {
    if (isValidDate(selectedDate)) {
      setDate(selectedDate);
      setErrorMsg("");
    } else {
      setDate(null);
      setErrorMsg("Start Date is mandatory");
    }
  };
  const handleBlur = () => {
    setTouched(true);
    if (!date) {
      setErrorMsg("Start Date is Mandatory and should be valid");
    } else if (!isValidDate(date)) {
      setErrorMsg("Invalid date format");
    }
  };

  return (
    <div className="form-container">
      <div className="form-group d-grid mb-0">
        <label htmlFor="date-picker" className="form-label">
          Start Date (UTC){' '}
          <span style={{ color: "red" }} aria-hidden="true">*</span>
          <span className="visually-hidden">&nbsp;required</span>
        </label>
        <DatePicker
          id="date-picker"
          value={date}
          onChange={handleChange}
          onOk={handleOk}
          onBlur={handleBlur}
          placeholder="MM-DD-YYYY"
          size="md"
          format="MM-dd-yyyy"
          oneTap
        />
        {touched && errorMsg && (
          <p className="datepickererror">{errorMsg}</p>
        )}
      </div>
    </div>
  );
};

export default CustDatePicker;
